import { KeyboardEvent } from 'react';
import { ChakraFlex, FAIconName, Icon, Text } from '@equip.health/ui';

interface FollowUpSlotProps {
  id: string;
  isDisabled?: boolean;
  isSelected: boolean;
  onSelect: (opening: FollowUpOpening) => void;
  opening: FollowUpOpening;
}

const FollowUpSlot = ({
  id,
  isDisabled = false,
  isSelected,
  onSelect,
  opening,
}: FollowUpSlotProps) => {
  const onKeyDown = (e: KeyboardEvent) => {
    if (isDisabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect(opening);
    }
  };

  return (
    <ChakraFlex
      _hover={
        isDisabled
          ? undefined
          : { borderColor: 'primary.100', backgroundColor: 'primary.10' }
      }
      alignItems="center"
      aria-disabled={isDisabled || undefined}
      backgroundColor={isSelected ? 'primary.10' : 'white'}
      borderColor={isSelected ? 'primary.100' : 'neutral.line'}
      borderRadius="12px"
      borderWidth="1px"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      gap="12px"
      height="100%"
      id={`${id}__follow-up-slot-${opening.startTime}`}
      justifyContent="space-between"
      onClick={isDisabled ? undefined : () => onSelect(opening)}
      onKeyDown={onKeyDown}
      opacity={isDisabled ? 0.4 : 1}
      padding="16px"
      role="listitem"
      tabIndex={isDisabled ? -1 : 0}
      width="100%"
    >
      <ChakraFlex direction="column" gap="2px">
        <Text
          color="neutral.secondary"
          id={`${id}__weekday`}
          variant="body"
        >
          {opening.dateLabel}
        </Text>
        <Text
          color="black"
          id={`${id}__time`}
          variant="bodyMedium"
        >
          {opening.timeLabel}
        </Text>
      </ChakraFlex>
      {isSelected && (
        <Icon color="primary.100" name={FAIconName.checkRegular} />
      )}
    </ChakraFlex>
  );
};

export default FollowUpSlot;
